import {Component} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from '../../../../../shared/services/translations.service';

@Component({
  templateUrl: './service-selector.component.html',
  styleUrls: ['./service-selector.component.scss']
})
export class ServiceSelectorComponent {
  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private translationService: TranslationService) {
    this.route.params.subscribe(params => {
      this.lang = params['lang'] || 'en';

      title.setTitle(this.translationService.getTranslation(this.lang, 'boosting_services_page_title'));
      meta.updateTag(
        {
          name: 'description',
          // tslint:disable-next-line:max-line-length
          content: this.translationService.getTranslation(this.lang, 'home_page_desc')
        }
      );
    });
  }
}
